import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-wrap center" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = { href: "/" }
const _hoisted_5 = { class: "right" }
const _hoisted_6 = { class: "tab-list" }
const _hoisted_7 = {
  key: 0,
  class: "nav-list-wrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("a", _hoisted_4, [
          _createVNode("img", {
            src: _ctx.images.logo,
            alt: ""
          }, null, 8, ["src"])
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabList, (item, index) => {
            return (_openBlock(), _createBlock("div", {
              class: ['tab-item', _ctx.activeTab === index ? 'active' : ''],
              key: item.uid,
              onClick: ($event: any) => (_ctx.switchTab(index))
            }, _toDisplayString(item.title), 11, ["onClick"]))
          }), 128))
        ]),
        _createVNode("div", {
          class: ['nav-list', _ctx.isShowNavList ? 'active' : '']
        }, [
          _createVNode("div", {
            class: "nav-name",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowNavList = !_ctx.isShowNavList))
          }, _toDisplayString(_ctx.tabList[_ctx.activeTab].title), 1),
          (_ctx.isShowNavList)
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabList, (item, index) => {
                  return (_openBlock(), _createBlock("div", {
                    class: ['nav-item'],
                    key: item.uid,
                    onClick: ($event: any) => (_ctx.switchNav(index))
                  }, _toDisplayString(item.title), 9, ["onClick"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ])
  ]))
}